// 모든 데모가 같은 예시 반(가명)으로 이야기하도록 예시 데이터를 한곳에 둔다.
// 이름은 실제 학생으로 오해하지 않도록 누구나 아는 예시 이름(홍길동·김철수·이영희)을 쓴다.

export const DEMO_CLASS = {
  label: '2학년 3반',
  size: 28,
  names: ['홍길동', '김철수', '이영희', '성춘향', '이몽룡', '심청', '임꺽정', '장화'],
};

export const DEMO_SAENGGIBU = {
  student: '홍길동',
  category: '교과세특',
  subject: '수학',
  memo: '이차함수 그래프 탐구 보고서 발표\n모둠 활동에서 친구 설명을 잘 도와줌',
  output:
    '이차함수 단원에서 계수에 따라 그래프가 어떻게 달라지는지 직접 그려 비교하는 탐구 보고서를 작성하고, 꼭짓점과 축의 관계를 근거로 들어 논리적으로 발표함. 모둠 활동에서 개념을 어려워하는 친구에게 그래프를 함께 그리며 차근차근 설명해 모둠 전체의 이해를 높임. 발표 뒤 친구들에게 받은 질문을 정리해 다음 시간에 스스로 찾은 답을 학급에 공유함.',
  byteLimit: 500,
};

export const DEMO_STYLE = {
  pasted:
    "'산과 염기' 단원 실험에서 지시약의 색 변화를 관찰해 결과를 표로 정리함. 실험 오차의 원인을 스스로 찾아 다음 실험 방법을 바꾸어 봄. 이 과정에서 근거를 들어 생각하는 힘이 자람.",
  fields: [
    { label: '문체', value: "'~함', '~봄'처럼 짧게 끝맺어요" },
    { label: '고정 문구·형식', value: "첫 문장은 '단원 이름'으로 시작해요" },
    { label: '서술 흐름', value: '활동 → 스스로 한 일 → 자란 점' },
  ],
  result: [
    { t: "'이차함수' 단원에서", style: true },
    { t: ' 계수에 따라 그래프가 달라지는 모습을 직접 그려 비교하는 탐구 보고서를 작성함. 꼭짓점과 축의 관계를 근거로 들어 발표하고, 개념을 어려워하는 친구에게 그래프를 함께 그리며 설명해 줌. ' },
    { t: '이 과정에서 근거를 들어 설명하는 힘이 자람.', style: true },
  ],
};

export const DEMO_IMAGE = {
  prompt: '물의 순환 과정을 초등 4학년이 보기 쉽게 그려줘',
  src: '/examples/images/img-water-cycle.webp',
  alt: 'AI가 만든 물의 순환 과정 그림 예시',
};

export const DEMO_WORKSHEET = {
  prompt: '광합성 단원평가 5문항, 정답지도 같이 만들어 줘',
  src: '/examples/worksheets/ws-science-mc.jpg',
  alt: 'AI가 만든 광합성 단원평가 학습지',
};

export const DEMO_CLASS_FLOW = {
  overlapSentence: '바른 자세로 수업에 참여하며 맡은 역할을…',
  overlapStudents: ['김철수', '이영희', '성춘향'],
  results: [
    { name: '홍길동', bytes: 1449 },
    { name: '김철수', bytes: 1482 },
    { name: '이영희', bytes: 1463 },
  ],
  byteLimit: 1500,
};

export const DEMO_SCORING = {
  fileName: '2학년3반_수행평가_스캔.pdf',
  pages: 56,
  ranges: [
    { name: '홍길동', pages: '1–2페이지' },
    { name: '김철수', pages: '3–4페이지' },
    { name: '이영희', pages: '5–6페이지' },
    { name: '성춘향', pages: '7–8페이지' },
  ],
  question: '청소년 수면 부족 문제의 원인과 해결 방안을 서술하시오.',
  answer: [
    { t: '청소년이 잠을 못 자는 ' },
    { t: '첫 번째 원인은 스마트폰이다.', hl: true },
    { t: ' 밤에 누워서 영상을 보다 보면 시간이 금방 간다. ' },
    { t: '두 번째 원인은 학원과 숙제 같은 학업 부담이다.', hl: true },
    { t: ' ' },
    { t: '우리 반에서도 아침에 조는 친구들이 많다.' },
    { t: ' 해결 방안으로는 ' },
    { t: '잠들기 1시간 전에 스마트폰을 거실에 두는 습관', hl: true },
    { t: '을 만드는 것이 좋다.' },
  ],
  score: 18,
  max: 20,
  criteria: [
    { name: '문제 원인 분석', score: 7, max: 8 },
    { name: '근거 활용', score: 3, max: 4 },
    { name: '해결 방안', score: 8, max: 8 },
  ],
};

export const DEMO_PPT = {
  kicker: '6학년 과학 · 날씨와 우리 생활',
  before: '물의 순환',
  after: '물이 여행하는 길',
  bullets: ['바다와 강의 물이 증발해 수증기가 돼요', '하늘에서 구름이 되고 비나 눈으로 내려요', '다시 강과 바다로 모여 순환해요'],
  image: '/examples/images/img-water-cycle.webp',
  thumbs: ['/examples/ppt/ppt-photosynthesis.webp', '/examples/ppt/ppt-solar-system.webp', '/examples/ppt/ppt-math-fractions.webp', '/examples/ppt/ppt-korean-history.webp'],
};

export const DEMO_CHAT = {
  question: '우리 반 수학 단원평가 점수를 구간별로 그래프로 정리해 줘',
  intro: '28명 점수를 20점 단위로 나눠 정리했어요.',
  rows: [
    { band: '90점 이상', count: 6 },
    { band: '70~89점', count: 11 },
    { band: '50~69점', count: 8 },
    { band: '50점 미만', count: 3 },
  ],
  outro: '70점 이상이 17명(61%)이에요. 50점 미만 3명은 다음 차시 전에 개별 보충을 권해요.',
};
